export default "__VITE_ASSET__DDJbjXIZ__"